import { PublicApiClient } from '@guiker/propsharing-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const usePublicPropSharingInquiryApiClient = useAuthenticatedApiClient(PublicApiClient)
